import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const Card = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e2e8f0;
  position: relative;
  overflow: hidden;
  transition: transform 0.2s ease, box-shadow 0.2s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .card-icon {
    position: absolute;
    top: 0;
    right: 0;
    padding: 1rem;
    opacity: 0.1;
    font-size: 5rem;
    transform: scale(1);
    transition: transform 0.3s ease;
  }

  h3 {
    font-size: 1.25rem;
    font-weight: 700;
    margin: 0 0 1rem 0;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    i {
      font-size: 1.125rem;
    }
  }

  p {
    color: #64748b;
    line-height: 1.6;
    margin: 0;
  }

  @media (max-width: ${screenSizes.mobile}) {
    padding: 1.5rem;
  }
`;
